import React, { useEffect, useState } from 'react';
/*
Hook for screen width and height to calculate size of card in showing when screen goes below 1440px 

*/
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

// for getting  proper colSize,row,pageSize

function getDimension(width) {
  let dimension = {
    pageSize: 0,
    row: 0,
    colSizeXl: 0,
  };

  if (width >= 2560) {
    dimension.colSizeXl = 4;

    dimension.row = 12;
    dimension.pageSize = 12;
  } else if (width >= 1600 && width <= 2559) {
    dimension.colSizeXl = 5;

    dimension.row = 10;

    dimension.pageSize = 10;
  } else if (width >= 1200 && width <= 1599) {
    dimension.colSizeXl = 6;

    dimension.row = 8;
    dimension.pageSize = 8;
  } else if (width >= 1000 && width <= 1199) {
    dimension.colSizeXl = 3;

    dimension.row = 6;
    dimension.pageSize = 6;
  } else if (width <= 999) {
    dimension.colSizeXl = 3;

    dimension.row = 6;
    dimension.pageSize = 6;
  }
  return dimension;
}

// for IPS data card view

// for getting  proper colSize,row,pageSize

function getIPSDimension(width) {
  let dimension = {
    pageSize: 0,
    row: 0,
    colSizeXl: 0,
  };

  if (width >= 2560) {
    dimension.colSizeXl = 4;

    dimension.row = 12;
    dimension.pageSize = 12;
  } else if (width >= 1600 && width <= 2559) {
    dimension.colSizeXl = 5;

    dimension.row = 10;

    dimension.pageSize = 10;
  } else if (width >= 1298 && width <= 1599) {
    dimension.colSizeXl = 6;

    dimension.row = 8;
    dimension.pageSize = 8;
  } else if (width >= 1200 && width <= 1298) {
    dimension.colSizeXl = 8;

    dimension.row = 6;
    dimension.pageSize = 6;
  } else if (width >= 1000 && width <= 1199) {
    dimension.colSizeXl = 3;

    dimension.row = 6;
    dimension.pageSize = 6;
  } else if (width <= 999) {
    dimension.colSizeXl = 3;

    dimension.row = 6;
    dimension.pageSize = 6;
  }
  return dimension;
}
export { useWindowDimensions, getDimension, getIPSDimension };
